import React from 'react'
import Header from '../../Components/Modules/Includes/Header'

import _ from 'lodash';
import { connect } from 'react-redux';
import * as actions from '../../Actions/index';
import Moment from 'react-moment';

class Dashboard extends React.Component{
	  constructor(props) {
	    super(props);
	    this.filterToggle = this.filterToggle.bind(this);
	    this.state = {
	    	open: false,
	    	filter: 'active-dashboard',
	    	jobSortIndex: 0,
	      	jobSortDirection: false,
	     	jobSearchText: '',
	      	jobs: []
	    }
	  }
	  componentDidMount() {
	    this.props.fetchJobs();
	  }
      handleOpen = () => {
        this.setState({open: true});
      };
      handleClose = () => {
        this.setState({open: false});
      };
	  filterToggle(){
		let value =  (this.state.filter === 'active-dashboard') ? 'deactivate-dashboard' : 'active-dashboard' 
	  	this.setState({ filter : value });
	  }
	  renderJobs() {
	  	// console.log(this.props.jobs);
	    if( !this.props.jobs || !this.props.jobs.items || this.props.jobs.items.length === 0 ) {
	      return null;
	    }

	    let jobs = _.clone(this.props.jobs.items);

	    if( this.state.jobSearchText ) {
	      jobs = _.filter(jobs, (job) => {
	        if( job.simpro_id.toString().indexOf(this.state.jobSearchText) !== -1 ) {
	          return true;
	        }
	        return false;
	      });
	    }

	    jobs.sort((a, b) => {
	      switch( this.state.jobSortIndex ) {
	        case 0:
	          return this.state.jobSortDirection ? a.simpro_id - b.simpro_id : b.simpro_id - a.simpro_id;
	        default:
	          return this.state.jobSortDirection ? a.simpro_id - b.simpro_id : b.simpro_id - a.simpro_id;
	      }
	    });

	    return jobs.map((j, i) => {
	      let siteName = _.has(j, 'simpro_job.Site.SiteName') ? j.simpro_job.Site.SiteName : '';
	      //var now = new Date(j.imported_at);
	    //   console.log(j.imported_at);
	      return (
	        <tr key={`job${j.simpro_id}`} onClick={() => {  }}>
				<td data-title="Job Id">{j.simpro_id}</td>
				<td data-title="Site">{siteName}</td>
				<td data-title="Status">{j.status}</td>
				<td data-title="Inported at">
					<Moment>
	                {j.imported_at}
	            	</Moment>
	            </td>
				<td data-title="Manaual Created?">
					<input type="checkbox" value="" defaultChecked={j.pdf_created_at ? true : false} className="checkboxs" />
					<span></span>
				</td>
			</tr>
	      );
	    });
	  }
      render() {
    	// const actions = [
     //      <FlatButton
     //        label="Cancel"
     //        primary={true}
     //        onClick={this.handleClose}
     //      />,
     //      <FlatButton
     //        label="Submit"
     //        primary={true}
     //        keyboardFocused={true}
     //        onClick={this.handleClose}
     //      />,
     //    ];
        let jobs = this.renderJobs();
        return(<div>
        		  <Header />
        		   <div className="dashboard-page">
                    <div className={`right-content-dashboard ${this.state.filter}`}>
	                   	{ /* <div className="dashboard-content-sec margb20px">
	                   		<h3>Starred</h3>
	                   		<div className="no-data-div">
	                   			<p>When you star items, they will appear here 
	                   			for easy access 
	                   				<button onClick={this.handleOpen} type="button" className="learn-more">Learn more</button>
	                   			</p>
	                   			<Dialog
			                          actions={actions}
			                          className="model-other"
			                          modal={false}
			                          contentClassName="model-top-overlay no-overlay"
			                          open={this.state.open}
			                          onRequestClose={this.handleClose}
			                        >       
	                            	<div className="other-popup-content learn-more-popup">
		                                <figure>
		                                	<img src="/images/user-img.jpg" alt="img" />
		                                </figure>	
		                                <h3>Starred Job !</h3>
		                                 <p>Lorem ipsum dolor sit amet, 
		                                 consectetur adipisicing elit, sed do eiusmod 
		                                 tempor incididunt ut labore et dolore magna aliqua.
		                                 Ut enim ad minim veniam,quis nostrud exercitation 
		                                 ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
		                            </div>
		                        </Dialog>
	                   		</div>
	                   		<div className="starred-job-list">
	                   			<ul>
	                   				<li>
	                   					<MdStars /> Job 2686 rehab studio
	                   				</li>
	                   				<li>
	                   					<MdStars /> Job 2829 DRC Capital
	                   				</li>
	                   			</ul>
	                   		</div>
	                   	</div>*/ }
	                   	<div className="dashboard-content-sec table-dashboard">
	                   		<h3>Jobs without manuals </h3>
	                   		<div className="dashboard-table-data">
	                   			<table className="dashboard-table" cellPadding="0" cellSpacing="0" width="100%">
	                   				<thead>
	                   					<tr>
	                   						<th>Job Id</th>
	                   						<th>Site</th>
	                   						<th>Status</th>
	                   						<th>Inported at</th>
	                   						<th>Manaual Created?</th>
	                   					</tr>
	                   				</thead>
	                   				<tbody>
	                   					{jobs}                   					
	                   				</tbody>
	                   			</table>
	                   		</div>
	                   		<div className="no-data-div">
	                   			<p>Jobs have been imported but have not been completed will show here.</p>
	                   		</div>
	                   	</div>
                   	 </div>
                  </div>
               </div>
            )
    }
} 

const mapStateToProps= (state,props)=> {
    return {
      currentUser : state.currentuser,
      jobs: state.jobs
    };
}
export default connect(mapStateToProps,actions)(Dashboard);



// WEBPACK FOOTER //
// ./src/Components/Pages/Dashboard.js